import React, { createContext } from 'react';
import PropTypes from 'prop-types';

export const YANDEX_MAPS_MODE_HASH = {
	development: 'debug',
	production: 'release'
};

const defaultYmaps = {
	loading: false,
	ymaps: null,
	error: null
};

const YandexMapsContext = createContext(defaultYmaps);

const YandexMapsProvider = ({ ymaps, children }) => (
	<YandexMapsContext.Provider value={ymaps}>
		{children}
	</YandexMapsContext.Provider>
);

YandexMapsProvider.propTypes = {
	children: PropTypes.node.isRequired,
	ymaps: PropTypes.shape({
		loading: PropTypes.bool,
		ymaps: PropTypes.object,
		error: PropTypes.object
	})
};

YandexMapsProvider.defaultProps = {
	...defaultYmaps
};

export { YandexMapsContext, YandexMapsProvider };
